import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Mail, Send, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const FORMSPREE_URL = "https://formspree.io/f/xbdqnqpw";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setL] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setL(true);
    try {
      const res = await fetch(FORMSPREE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(f),
      });
      if (!res.ok) throw new Error("failed");
      setSent(true);
      toast.success("Message sent!");
    } catch { toast.error("Failed to send. Please try again."); }
    finally { setL(false); }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-12 py-14">
      <div className="text-xs uppercase tracking-[0.25em] text-zinc-500">Contact</div>
      <h1 className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Talk to us.</h1>
      <p className="mt-3 text-zinc-400">We respond within 24 hours, Mon–Fri.</p>

      <div className="mt-10 grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2 glass-strong rounded-2xl p-7">
          {sent ? (
            <div className="text-center py-10">
              <CheckCircle2 size={48} className="mx-auto text-emerald-400"/>
              <h3 className="mt-4 text-xl font-bold">Thanks! We got your message.</h3>
              <p className="text-sm text-zinc-400 mt-2">We'll get back to you at {f.email} soon.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs uppercase tracking-widest text-zinc-400">Name</Label>
                  <Input data-testid="contact-name" required value={f.name} onChange={e=>setF({...f,name:e.target.value})} className="mt-1.5"/>
                </div>
                <div>
                  <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
                  <Input data-testid="contact-email" type="email" required value={f.email} onChange={e=>setF({...f,email:e.target.value})} className="mt-1.5"/>
                </div>
              </div>
              <div>
                <Label className="text-xs uppercase tracking-widest text-zinc-400">Subject</Label>
                <Input data-testid="contact-subject" required value={f.subject} onChange={e=>setF({...f,subject:e.target.value})} className="mt-1.5"/>
              </div>
              <div>
                <Label className="text-xs uppercase tracking-widest text-zinc-400">Message</Label>
                <Textarea data-testid="contact-message" required rows={5} value={f.message} onChange={e=>setF({...f,message:e.target.value})} className="mt-1.5"/>
              </div>
              <Button type="submit" disabled={loading} className="bg-indigo-600 hover:bg-indigo-700 glow-primary" data-testid="contact-submit-btn">
                <Send size={14} className="mr-2"/>{loading ? "Sending…" : "Send message"}
              </Button>
            </form>
          )}
        </div>
        <div className="space-y-4">
          <div className="glass rounded-2xl p-5">
            <Mail size={18} className="text-cyan-300"/>
            <div className="mt-3 font-semibold">Support email</div>
            <div className="text-sm text-zinc-400 mt-0.5">support@humanizeai.app</div>
          </div>
          <div className="glass rounded-2xl p-5">
            <div className="text-xs uppercase tracking-widest text-zinc-400">Response time</div>
            <div className="mt-1 font-semibold">Within 24 hours</div>
            <div className="text-sm text-zinc-400 mt-0.5">Pro & Business get priority response.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
